import { CharacterRes } from "./CharParseImportList";

export function charsToLetters(characters: CharacterRes[]): string[] {
  const result: string[] = characters.map(
    (character: CharacterRes) => character.letter
  );

  return result;
}
